// /src/components/layout/Header.tsx
import React from 'react';
import { Box, Flex, Text, Button, Avatar, HStack } from '@chakra-ui/react';
import { useAuth } from '../../hooks/useAuth';

export const Header: React.FC = () => {
  const { usuario, logout } = useAuth();

  return (
    <Box bg="white" px={4} py={3} boxShadow="sm" borderBottom="1px" borderColor="gray.200">
      <Flex justify="space-between" align="center">
        <Text fontSize="xl" fontWeight="bold" color="blue.600">
          CertificaPro
        </Text>
        
        {usuario && (
          <HStack spacing={4}>
            <HStack spacing={2}>
              <Avatar size="sm" name={usuario.nombre} bg="blue.500" />
              <Box>
                <Text fontSize="sm" fontWeight="medium">{usuario.nombre}</Text>
                <Text fontSize="xs" color="gray.600">{usuario.rol}</Text>
              </Box>
            </HStack>
            <Button size="sm" colorScheme="red" variant="outline" onClick={logout}>
              Cerrar Sesión
            </Button>
          </HStack>
        )}
      </Flex>
    </Box>
  );
};
